export default '/build/238446a8.svg'